import { Button, CardMedia, Container, CssBaseline, makeStyles, TextField, Typography } from '@material-ui/core';
import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Logo from '../../../assets/Login_logo.png';
import Background from '../../../assets/Background.jpg';
import PrivacyFooter from '../footer';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(12),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    media: {
        height: 0,
        paddingBottom: '10.25%', // 16:9
    },
    borderline: {
        borderBottom: '1px solid #000',
        width: '20%',
        paddingTop: '3%',
        marginBottom: '10%',
    },
    bgImage: {
        width: '100%',
        backgroundImage: `url(${Background})`,
        backgroundSize: 'cover',
        height: '100vh',
    },
    reset: {
        margin: theme.spacing(3, 0, 2),
        background: '#f8961d',
        '&:hover': {
            background: '#fdac48',
        },
        border: '1px solid #ef8400',
        borderRadius: '5px',
        fontFamily: 'Rubik',
        width: '50%',
    },
    fullWidth: {
        width: '100%',
    },
    errorReset: {
        color: 'red',
        fontSize: '0.8rem',
        paddingLeft: '5px',
    },
    centerAlign: {
        textAlign: 'center',
    },
}));

function ForgotPasswordScreen() {
    const classes = useStyles();

    const formik = useFormik({
        initialValues: {
            currentpassword: '',
            password: '',
            confirmpassword: '',
        },
        validationSchema: Yup.object({
            currentpassword: Yup.string().required('Please enter your Current Password'),
            password: Yup.string().min(6, 'Password must be atleast 6 characters').required('Enter New Password'),
            confirmpassword: Yup.string()
                .oneOf([Yup.ref('password'), null], 'Password Should match')
                .required('Confirm Password is required'),
        }),
        onSubmit: () => {},
    });

    return (
        <div className={classes.bgImage}>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <div className={classes.paper}>
                    <Typography component="h1" variant="h5">
                        Welcome to
                    </Typography>
                    <CardMedia className={classes.media}>
                        <img src={Logo} alt="logo" />
                    </CardMedia>
                    <div className={classes.borderline} />

                    <Typography variant="h6"> Reset your password </Typography>

                    <div className={classes.fullWidth}>
                        <form onSubmit={formik.handleSubmit}>
                            <TextField
                                type="password"
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                id="currentpassword"
                                label="Current password"
                                name="currentpassword"
                                autoComplete="current-password"
                                required
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.currentpassword}
                            />
                            {formik.touched.currentpassword && formik.errors.currentpassword ? (
                                <span className={classes.errorReset}>{formik.errors.currentpassword}</span>
                            ) : null}
                            <TextField
                                type="password"
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                id="password"
                                label="Password"
                                name="password"
                                autoComplete="Password"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.password}
                            />
                            {formik.touched.password && formik.errors.password ? (
                                <span className={classes.errorReset}>{formik.errors.password}</span>
                            ) : null}
                            <TextField
                                type="password"
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                id="confirmpassword"
                                label="Confirm password"
                                name="confirmpassword"
                                autoComplete="Confirm-Password"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.confirmpassword}
                            />
                            {formik.touched.confirmpassword && formik.errors.confirmpassword ? (
                                <span className={classes.errorReset}>{formik.errors.confirmpassword}</span>
                            ) : null}

                            <Button type="submit" fullWidth variant="contained" color="primary" className={classes.reset}>
                                RESET
                            </Button>
                        </form>
                    </div>
                </div>
            </Container>
            {/* <div className="btmMenu">
                <div className="btmLogo">
                    <img src={Logo} alt="logo" className={classes.logo} />
                </div>
                <div className="btmLogin">
                    <ul className="displayInline">
                        <li>&#169; Copyright 2021 Advith ITeC</li>
                        <li>Privacy Policy</li>
                        <li>Contact Us</li>
                        <li>Terms and Condition</li>
                    </ul>
                </div>
            </div> */}
            <PrivacyFooter />
        </div>
    );
}

export default ForgotPasswordScreen;
